import { useCallback } from 'react';
import { useNavigation } from '@react-navigation/native';

import { type PartialProduct } from '../../../../graphql';
import { type BagScreenProps } from '../../../../navigation/AppNavigation.props';

/**
 * Hook that allows navigating to the correct edit customization page.
 */
export const useNavigateToCustomizationEditScreen = (props: Params) => {
  const { addressId = '', restaurantSlug = '', isDelivery = false } = props;

  const navigation = useNavigation<BagScreenProps['navigation']>();

  const navigateToCustomizationEditScreen = useCallback(
    (params: NavigateToCustomizationEditParams) => {
      const { lineItemId, product } = params;
      const productSlug = product?.slug ?? '';

      if (isDelivery) {
        navigation.navigate('CustomizationDeliveryEdit', {
          addressId,
          productSlug,
          lineItemId,
        });

        return;
      }

      navigation.navigate('CustomizationEdit', {
        restaurantSlug,
        productSlug,
        lineItemId,
      });
    },
    [addressId, isDelivery, navigation, restaurantSlug],
  );

  return { navigateToCustomizationEditScreen };
};

// ─── TYPES ──────────────────────────────────────────────────────────────────────

type Params = Readonly<{
  isDelivery?: boolean;
  addressId?: string;
  restaurantSlug?: string;
}>;

type NavigateToCustomizationEditParams = Readonly<{
  lineItemId: string;
  product: PartialProduct;
}>;
